import React, { Component } from 'react'
import { connect } from 'react-redux'
import yn from 'yn'

class BkFlowEditGuestFieldAdults extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			sessionProperty,
			configProperty,
			currentAdults,
			currentChildren,
			addAdult,
			removeAdult
		} = this.props

		const hotelLabels = configData.hotel.labels[0]
		const combinedGuestsValue = currentAdults + currentChildren

		// Disable guest field based on combinedGuestTotal or maximumAdults values in flowQueryConfig
		let guestFieldDisabled = false

		if (
			sessionProperty &&
			sessionProperty.combinedGuestTotal
		) {
			if (Number(combinedGuestsValue) === Number(sessionProperty.combinedGuestTotal)) {
				guestFieldDisabled = true
			} else if (Number(sessionProperty.maximumAdults) === Number(currentAdults)) {
				guestFieldDisabled = true
			}
		} else if (
			configProperty &&
			configProperty.combinedGuestTotal
		) {
			if (Number(combinedGuestsValue) === Number(configProperty.combinedGuestTotal)) {
				guestFieldDisabled = true
			} else if (Number(configProperty.maximumAdults) === Number(currentAdults)) {
				guestFieldDisabled = true
			}
		} else if (
			sessionProperty &&
			sessionProperty.maximumAdults &&
			Number(sessionProperty.maximumAdults) === Number(currentAdults)
		) {
			guestFieldDisabled = true
		} else if (
			configProperty &&
			configProperty.maximumAdults &&
			Number(configProperty.maximumAdults) === Number(currentAdults)
		) {
			guestFieldDisabled = true
		}

		return (
			<div className="bk-flow-edit-guest__field-input row center-xs">
				<p className="bk-flow-edit-guest__field-heading u-font-xs u-remove-margin">
					{ hotelLabels.adults ? hotelLabels.adults : 'Adults' }
					{yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_ADULT_AGE_LABELS) ?
						hotelLabels.adultAgeGroup ? ' ' + hotelLabels.adultAgeGroup : ' (13+ years)'
						: null
					}
				</p>
				<button
					className="bk-flow-edit-guest__field-input-btn decrement col-xs"
					onClick={ () => removeAdult() }
					onKeyDown={
						currentAdults === 1 ?
							null
						: e => e.keyCode === 13 || e.keyCode === 32 ?
							removeAdult()
						:
							null
					}
					disabled={ currentAdults === 1 }
					tabIndex={ 2 }
				>
					-
				</button>

				<div className="bk-flow-edit-guest__field-input-value col-xs">{ currentAdults }</div>

				<button
					className="bk-flow-edit-guest__field-input-btn increment col-xs"
					onClick={ guestFieldDisabled ? null : () => addAdult() }
					onKeyDown={ guestFieldDisabled ?
							null
						: e => e.keyCode === 13 || e.keyCode === 32 ?
							addAdult()
						:
							null
					}
					disabled={ guestFieldDisabled }
					tabIndex={ 2 }
				>
					+
				</button>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration
})

export default connect(mapStateToProps, null)(BkFlowEditGuestFieldAdults)


// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldAdults.js